import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import {
  faCoin,
  faMagnifyingGlass,
  faShoppingBasket,
  faShoppingCart,
  faSignOut,
  faTruck,
  faUser,
  faWallet,
  faCartPlus,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useState } from "react";
import { getSaldo } from "../../api/orgadots";
import { isMobile } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import styled, { useTheme } from "styled-components";
import Logo from "../../assets/organnactwhite.png";
import { logout } from "../../redux/slices/authSlice";
import { SearchContext } from "../../routes";
import { faBars, faTimes } from "@fortawesome/pro-solid-svg-icons";

const DefaultMenuItems = [
  {
    icon: faShoppingBasket,
    label: "Produtos",
    link: "/",
  },
  {
    icon: faWallet,
    label: "Extrato OrgaDots",
    link: "/extrato",
  },
  {
    icon: faUser,
    label: "Perfil e conta",
    link: "/perfil",
  },
  {
    icon: faTruck,
    label: "Meus pedidos",
    link: "/pedidos",
  },
  {
    icon: faWhatsapp,
    label: "Preciso de ajuda",
    link: "https://wa.me/554191946899",
    external: true,
    help: true,
  },
];

function Header({ hideSearch = false, menuItems = DefaultMenuItems }) {
  const dispatch = useDispatch();
  const theme = useTheme();

  const [open, setOpen] = useState(false);
  const [saldo, setSaldo] = useState(null);
  const { needle, setNeedle } = useContext(SearchContext);
  const { isAuthenticated, user, admin } = useSelector(
    (state) => state.authReducer
  );
  const { items } = useSelector((state) => state.cartReducer);
  const { role } = user || {};
  const isDistribuidor = user?.roles?.includes("distribuidor");

  const totalItems = items.reduce((acc, item) => acc + item.quantidade, 0);
  const isEqui = theme?.name === "equi";

  useEffect(() => {
    if (user?.id && isDistribuidor) {
      getSaldo(user.id)
        .then((data) => setSaldo(data.saldo || 0))
        .catch(() => {});
    }
  }, [user?.id]);

  const navigate = useNavigate();

  function updateNeedle(event) {
    setNeedle(event.target.value);
  }

  function handleSearchSubmit(event) {
    event.preventDefault();
    if (needle.trim() !== "") {
      navigate("/listagem");
    }
  }

  function _signout() {
    dispatch(logout());
    navigate("/");
  }

  function toggleMenu() {
    setOpen((prev) => !prev);
  }

  const parsedMenu = menuItems.map((item) => {
    if (item.help) {
      const gestorPhone = '554191946899';
      item.link = gestorPhone
        ? `https://api.whatsapp.com/send?phone=${gestorPhone}`
        : item.link;
    }
    return item;
  });

  if (isMobile) {
    return (
      <MobileHeaderContainer>
        <TopBar>
          <img
            src={Logo}
            alt="Organnact Logo"
            style={{ height: 40, cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
          <MobileActions>
            {isDistribuidor && (
              <MobileCartBtn onClick={() => navigate("/carrinho")}>
                <FontAwesomeIcon icon={faShoppingCart} />
                {totalItems > 0 && <CartBadge>{totalItems}</CartBadge>}
              </MobileCartBtn>
            )}
            <HamburgerButton onClick={toggleMenu}>
              <FontAwesomeIcon icon={open ? faTimes : faBars} />
            </HamburgerButton>
          </MobileActions>
        </TopBar>
        {!hideSearch && (
          <MobileSearchWrap>
            <SearchFieldContainer>
              <form onSubmit={handleSearchSubmit} style={{ width: "100%" }}>
                <SearchInput value={needle} onChange={updateNeedle} placeholder="Buscar produtos..." />
              </form>
              <SearchIcon>
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </SearchIcon>
            </SearchFieldContainer>
          </MobileSearchWrap>
        )}
        {open && (
          <MobileMenu>
            {isDistribuidor && saldo !== null && (
              <MobileSaldo onClick={() => navigate("/extrato")}>
                <FontAwesomeIcon icon={faCoin} color={theme.primary} />
                <span style={{ fontWeight: 600 }}>
                  {parseFloat(saldo).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                </span>
                <span style={{ fontSize: 11, color: "#999" }}>OrgaDots</span>
              </MobileSaldo>
            )}
            {parsedMenu.map((item, idx) => (
              <MobileMenuItem
                key={idx}
                onClick={() => {
                  setOpen(false);
                  if (item.external) {
                    window.open(item.link, "_blank");
                  } else {
                    navigate(item.link);
                  }
                }}
              >
                <FontAwesomeIcon icon={item.icon} />
                {item.label}
              </MobileMenuItem>
            ))}
            <MobileMenuItem onClick={_signout}>
              <FontAwesomeIcon icon={faSignOut} />
              Sair
            </MobileMenuItem>
          </MobileMenu>
        )}
      </MobileHeaderContainer>
    );
  }

  return (
    <>
      <HeaderWrapper $bg={theme.primary}>
        <HeaderInner>
          <HeaderLogo>
            <img
              src={Logo}
              alt="Organnact Logo"
              style={{ height: 50, cursor: "pointer", display: "block", marginBottom: -20 }}
              onClick={() => navigate("/")}
            />
          </HeaderLogo>

          {!hideSearch && (
            <HeaderSearch>
              <SearchFieldContainer>
                <form onSubmit={handleSearchSubmit} style={{ width: "100%" }}>
                  <SearchInput value={needle} onChange={updateNeedle} placeholder="Buscar produtos..." />
                </form>
                <SearchIcon>
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </SearchIcon>
              </SearchFieldContainer>
            </HeaderSearch>
          )}

          <HeaderActions>
            {isDistribuidor && saldo !== null && (
              <SaldoDisplay onClick={() => navigate("/extrato")}>
                <FontAwesomeIcon icon={faCoin} color={isEqui ? "#FFD700" : theme.primary} />
                <span style={{ fontWeight: 600 }}>
                  {parseFloat(saldo).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                </span>
                <span style={{ fontSize: 11, opacity: 0.7 }}>OrgaDots</span>
              </SaldoDisplay>
            )}
            {isDistribuidor && (
              <CartButton $isEqui={isEqui} onClick={() => navigate("/carrinho")}>
                <FontAwesomeIcon icon={faShoppingCart} />
                {totalItems > 0 && <CartBadge>{totalItems}</CartBadge>}
              </CartButton>
            )}
          </HeaderActions>
        </HeaderInner>
      </HeaderWrapper>

      <NavBar $bg={theme.primary}>
        <NavInner>
          {parsedMenu.map((item, index) => (
            <NavItem
              key={index}
              $isEqui={isEqui}
              $active={item.link === "/" && window.location.pathname === "/"}
              onClick={() => {
                if (item.external) {
                  window.open(item.link, "_blank");
                } else {
                  navigate(item.link);
                }
              }}
            >
              <FontAwesomeIcon icon={item.icon} />
              {item.label}
            </NavItem>
          ))}
          <NavDivider $isEqui={isEqui} />
          <NavItem $isEqui={isEqui} onClick={_signout}>
            <FontAwesomeIcon icon={faSignOut} />
            Sair
          </NavItem>
        </NavInner>
      </NavBar>
    </>
  );
}

/* ========== DESKTOP STYLES ========== */

const HeaderWrapper = styled.div`
  background-color: ${props => props.$bg};
`;

const HeaderInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
`;

const HeaderLogo = styled.div`
  flex-shrink: 0;
`;

const HeaderSearch = styled.div`
  flex: 1;
  max-width: 600px;
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex-shrink: 0;
`;

const SaldoDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: ${props => props.theme?.name === "equi" ? "#fff" : "#333"};
  background: rgba(255, 255, 255, ${props => props.theme?.name === "equi" ? "0.25" : "0.75"});
  padding: 6px 12px;
  border-radius: 20px;
  cursor: pointer;
  white-space: nowrap;
`;

const CartButton = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  color: ${props => props.$isEqui ? "#fff" : "#333"};
  cursor: pointer;
  position: relative;
`;

const CartBadge = styled.span`
  background: ${props => props.theme?.name === "equi" ? "#ff5900" : "#3483fa"};
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -8px;
  right: -10px;
`;

const NavBar = styled.div`
  background-color: ${props => props.$bg};
`;

const NavInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
  display: flex;
  align-items: center;
  gap: 24px;
`;

const NavItem = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: ${props => props.$isEqui ? "#fff" : "#333"};
  opacity: ${props => props.$active ? 1 : (props.$isEqui ? 0.85 : 1)};
  padding: 8px 0;
  cursor: pointer;
  border-bottom: 2px solid ${props => props.$active ? (props.$isEqui ? "#fff" : "#333") : "transparent"};
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;

  &:hover {
    border-bottom-color: ${props => props.$isEqui ? "#fff" : "#333"};
    opacity: 1;
  }
`;

const NavDivider = styled.div`
  width: 1px;
  height: 20px;
  background: ${props => props.$isEqui ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.15)"};
`;

const SearchFieldContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

const SearchIcon = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #e6e6e6;
  color: #666;
  font-size: 14px;
  cursor: pointer;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 11px 44px 11px 16px;
  border: none;
  border-radius: 4px;
  font-size: 15px;
  font-family: 'Montserrat', sans-serif;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  outline: none;
  color: #424242;
`;

/* ========== MOBILE STYLES ========== */

const MobileHeaderContainer = styled.div`
  background-color: ${props => props.theme.primary};
`;

const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
`;

const MobileActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const MobileCartBtn = styled.div`
  color: ${props => props.theme?.name === "equi" ? "#fff" : "#333"};
  font-size: 18px;
  position: relative;
  cursor: pointer;
`;

const HamburgerButton = styled.button`
  background: none;
  border: none;
  color: ${props => props.theme?.name === "equi" ? "#fff" : "#333"};
  font-size: 24px;
  cursor: pointer;
`;

const MobileSearchWrap = styled.div`
  padding: 0 15px 10px;
`;

const MobileMenu = styled.div`
  background-color: white;
  border-radius: 0 0 10px 10px;
  margin: 0 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

const MobileSaldo = styled.div`
  padding: 12px 20px;
  display: flex;
  gap: 6px;
  align-items: center;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #eee;
  cursor: pointer;
`;

const MobileMenuItem = styled.div`
  padding: 12px 20px;
  display: flex;
  gap: 10px;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  border-bottom: 1px solid #eee;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }
`;

export default Header;
